/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { TenantConfigDto } from '../model';
// @ts-ignore
import type { UpsertTenantConfigCommand } from '../model';
/**
 * TenantAppConfigApi - axios parameter creator
 */
export const TenantAppConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [sourceTenantId] 
         * @param {number} [targetTenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantAppConfigCopyData: async (sourceTenantId?: number, targetTenantId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/TenantAppConfig/CopyData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (sourceTenantId !== undefined) {
                localVarQueryParameter['sourceTenantId'] = sourceTenantId;
            }

            if (targetTenantId !== undefined) {
                localVarQueryParameter['targetTenantId'] = targetTenantId;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantAppConfigGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/TenantAppConfig/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertTenantConfigCommand} [upsertTenantConfigCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantAppConfigUpsert: async (upsertTenantConfigCommand?: UpsertTenantConfigCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/TenantAppConfig/Upsert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertTenantConfigCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantAppConfigApi - functional programming interface
 */
export const TenantAppConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantAppConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [sourceTenantId] 
         * @param {number} [targetTenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantAppConfigCopyData(sourceTenantId?: number, targetTenantId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantAppConfigCopyData(sourceTenantId, targetTenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantAppConfigApi.tenantAppConfigCopyData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantAppConfigGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantAppConfigGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantAppConfigApi.tenantAppConfigGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertTenantConfigCommand} [upsertTenantConfigCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantAppConfigUpsert(upsertTenantConfigCommand?: UpsertTenantConfigCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantAppConfigUpsert(upsertTenantConfigCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantAppConfigApi.tenantAppConfigUpsert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TenantAppConfigApi - factory interface
 */
export const TenantAppConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantAppConfigApiFp(configuration)
    return {
        /**
         * 
         * @param {TenantAppConfigApiTenantAppConfigCopyDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantAppConfigCopyData(requestParameters: TenantAppConfigApiTenantAppConfigCopyDataRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.tenantAppConfigCopyData(requestParameters.sourceTenantId, requestParameters.targetTenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantAppConfigGetAll(options?: RawAxiosRequestConfig): AxiosPromise<TenantConfigDto> {
            return localVarFp.tenantAppConfigGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantAppConfigApiTenantAppConfigUpsertRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantAppConfigUpsert(requestParameters: TenantAppConfigApiTenantAppConfigUpsertRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.tenantAppConfigUpsert(requestParameters.upsertTenantConfigCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for tenantAppConfigCopyData operation in TenantAppConfigApi.
 */
export interface TenantAppConfigApiTenantAppConfigCopyDataRequest {
    readonly sourceTenantId?: number

    readonly targetTenantId?: number
}

/**
 * Request parameters for tenantAppConfigUpsert operation in TenantAppConfigApi.
 */
export interface TenantAppConfigApiTenantAppConfigUpsertRequest {
    readonly upsertTenantConfigCommand?: UpsertTenantConfigCommand
}

/**
 * TenantAppConfigApi - object-oriented interface
 */
export class TenantAppConfigApi extends BaseAPI {
    /**
     * 
     * @param {TenantAppConfigApiTenantAppConfigCopyDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public tenantAppConfigCopyData(requestParameters: TenantAppConfigApiTenantAppConfigCopyDataRequest = {}, options?: RawAxiosRequestConfig) {
        return TenantAppConfigApiFp(this.configuration).tenantAppConfigCopyData(requestParameters.sourceTenantId, requestParameters.targetTenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public tenantAppConfigGetAll(options?: RawAxiosRequestConfig) {
        return TenantAppConfigApiFp(this.configuration).tenantAppConfigGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantAppConfigApiTenantAppConfigUpsertRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public tenantAppConfigUpsert(requestParameters: TenantAppConfigApiTenantAppConfigUpsertRequest = {}, options?: RawAxiosRequestConfig) {
        return TenantAppConfigApiFp(this.configuration).tenantAppConfigUpsert(requestParameters.upsertTenantConfigCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

